@if (store.loading$()) {
  <ngx-skeleton-loader
    class="w-9 h-9 rounded-full"
    [theme]="{ width: '36px', height: '36px', 'border-radius': '100vw' }"
  />
} @else if (!isPanelOpen()) {
  <button
    mat-icon-button
    class="mat-big-plus-icon-button"
    data-testid="notifications-button-trigger"
    (click)="togglePanel()"
    aria-label="Open notifications"
  >
    <div
      class="flex items-center justify-center bg-shikenso-gray-base rounded-full w-9 h-9 absolute top-0 right-0 hover:bg-transparent z-10"
    >
      <app-icon src="/icons/bell.svg" class="w-5 h-5" />

      @if (hasNewNews()) {
        <span class="absolute top-[10px] right-[10px] w-1 h-1 rounded-full bg-shikenso-error-base"></span>
      }
    </div>
  </button>
}

<app-notifications-panel
  [news]="store.news$()"
  [isOpen]="isPanelOpen()"
  (closePanel)="onClosePanel()"
  (newsClick)="onNewsItemClick($event)"
  [class.hidden]="!isPanelOpen()"
/>
